import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {ApiService} from '../../services/api.service';
import {HttpClient} from '@angular/common/http';
import {Store} from '../../store';
import {catchError, map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class QuestionnaireService {
    env = environment;

    constructor(
        private apiService: ApiService,
        private http: HttpClient,
        private store: Store,
    ) {
    }

    getQuestionnaire(requestId) {
        return this.http.get(this.env.apiPath + 'questionnaire/public/' + requestId, this.apiService.getHttpOptions())
            .pipe(
                map((data: any) => {
                        return data;
                    },
                    catchError(this.apiService.handleError)
                ));
    }

    completeQuestionnaire(questionnaire) {
        const user = this.store.selectForLocal('user');

        const dataToSend = {
            questionnaire,
            user,
        };

        return this.http.post(this.env.apiPath + 'questionnaire/public/', dataToSend, this.apiService.getHttpOptions())
            .pipe(
                map((data: any) => {
                        return data;
                    },
                    catchError(this.apiService.handleError)
                ));
    }

}
